import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {SocialMediaBarComponent} from '../../../../shared/toolbox/social-media-bar/social-media-bar.component';
import {SocialMedia} from '../company-metrics/company-metrics.interface';
import {NgIf, NgOptimizedImage} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import { EditOverlayComponent } from '../edit-overlay/edit-overlay.component';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-company-general-info',
  templateUrl: './company-general-info.component.html',
  styleUrls: ['./company-general-info.component.scss'],
  standalone: true,
  imports: [
    SocialMediaBarComponent,
    NgIf,
    NgOptimizedImage,
    MatCardModule,
    EditOverlayComponent,
  ],
})
export class CompanyGeneralInfoComponent implements OnInit, OnDestroy {
  public isEditMode: boolean = false; // Add this line
  private editModeSubscription!: Subscription; // Use definite assignment assertion


  constructor(
    public auth: RxAuthService,
    public specialRoutingService: SpecialRoutingService,
    private settingsService: SettingsService
  ) {}

  @Input() socialMedia: SocialMedia | undefined;
  @Input() companyWebDomain: string | undefined;
  @Input() companyLogo: string | undefined;
  @Input() companyIrn: string | undefined;
  @Input() profileUrl: string | undefined;

  ngOnInit(): void {
    // Subscribe to the edit mode state
    this.editModeSubscription = this.settingsService.editMode$.subscribe(
      (state) => {
        this.isEditMode = state;
      }
    );
    this.socialMedia = this.filterSocials();
    // console.log('SOC', this.socialMedia);

  }

  filterSocials(): SocialMedia | undefined {
    const desiredOrder: Array<keyof SocialMedia> = [
      'instagram',
      'facebook',
      'youtube',
      'tiktok',
      'x',
      'linkedin',
    ];

    // Check if this.socialMedia is defined
    if (this.socialMedia) {
      // Create a new object to hold the filtered social media
      const filteredSocialMedia: SocialMedia = {
        instagram: '',
        facebook: '',
        youtube: '',
        tiktok: '',
        x: '',
        linkedin: '',
      };

      // Iterate over the desired order and assign values if they exist
      desiredOrder.forEach((key) => {

        if (this.socialMedia && this.socialMedia[key] !== undefined) { // Check if the property exists
          filteredSocialMedia[key] = this.socialMedia[key]; // Access directly
        }
      });

      // console.log(filteredSocialMedia);
      return filteredSocialMedia; // Return the filtered social media
    } else {
      console.log('Social media data is undefined');
      return undefined; // Return undefined if social media is not defined
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.editModeSubscription) {
      this.editModeSubscription.unsubscribe();
    }
  }

  editProfile(id: number) {
    const baseUrl = '/research';
    const match = this.companyIrn;
    const metaNameId = this.companyIrn;
    const regionCode = 'ALL';
    const languageCode = 'ENG';
    const url = this.profileUrl;

    if (id === 1) {
      const formId = 2;
      const matchType = 1;

      const queryParams = {
        form_id: String(formId),
        match_type: String(matchType),
        match: match,
        meta_name_id: metaNameId,
        region_code: regionCode,
        language_code: languageCode,
        url: url, // Encode the URL
      };

      const route = {
        path: baseUrl, // Only the base path
        queryParams: queryParams, // The query parameters as an object
      };

      this.specialRoutingService.redirectToMRAPath(route);
    } else if (id === 5) {
      const formId = 53;
      const matchType = 1;

      const queryParams = {
        form_id: String(formId),
        match_type: String(matchType),
        match: match,
        meta_name_id: metaNameId,
        region_code: regionCode,
        language_code: languageCode,
        url: url, // Encode the URL
      };

      const route = {
        path: baseUrl, // Only the base path
        queryParams: queryParams, // The query parameters as an object
      };

      this.specialRoutingService.redirectToMRAPath(route);
    } else {
      console.log('ID not found');
    }
  }

  editDomain() {
    this.editProfile(5); // Call the editProfile method with the appropriate ID
  }

  editSocials() {
    this.editProfile(5); // Call the editProfile method with the appropriate ID
  }

  // New method to handle logo edit click
  editLogo() {
    this.editProfile(1); // Call the editProfile method with the appropriate ID
  }

  isValidUrl(string: string) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z0-9](?:[a-z0-9-]*[a-z0-9])?)\\.)+[a-z]{2,}|' + // domain name
        'localhost|' + // localhost
        '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|' + // IP address
        '\\[?[a-f0-9]*:[a-f0-9:%.~+\\-]*\\]?)' + // IPv6
        '(\\:\\d+)?(\\/[-a-z0-9+&@#/%=~_|\\?\\.:,]*)*$',
      'i'
    ); // path
    return !!urlPattern.test(string);
  }
}
